import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Row, Col, Dropdown, Button, Menu, Avatar, Input, Drawer } from 'antd';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  LoginOutlined,
  SearchOutlined
} from '@ant-design/icons';

const { Header } = Layout;

const menu = (
  <Menu>
    <Menu.Item icon={<LoginOutlined />}>
      <a rel="noopener noreferrer" href="/login" >
        Logout
      </a>
    </Menu.Item>
  </Menu>
);

// const onSearch = value => console.log(value);


class MainHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }



  render() {
    // console.log('this.props', this.props);
    const { placement, visible } = this.state;
    return (
      <div>
        <Header id="header"
          style={{ display: this.props.location.includes('/login') ? 'none' : '' }}
          role="header"
        >
          <Row wrap={false} justify="space-between" align="middle">
            <Col>
              <Button type="text" onClick={this.props.handleClickMenuArrow}>
                {React.createElement(this.props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                  className: 'trigger',
                })}
              </Button>
            </Col>
            <Col>
              <ul className="headerMenu">
                <li>
                  <Input.Group className="headerSearch">
                    <Input allowClear style={{ width: '200px' }} size="middle" placeholder="Search..."
                      onChange={
                        (e) => {
                          if (e.target.value === '') {
                            this.props.handleClickSearchClear(e)
                          } else {
                            this.props.handleInputSearch(e.target.value)
                          }
                        }
                      }
                      onPressEnter={(e) => this.props.handleClickSearch(e)}
                    />
                    <Button size="middle" type="primary" icon={<SearchOutlined />}
                      onClick={(e) => this.props.handleClickSearch(e)}
                      danger ></Button>
                  </Input.Group>
                </li>
                <li>
                  <Button icon={<LogoutOutlined />} href="/login">
                    Logout
                  </Button>
                </li>
              </ul>
            </Col>
          </Row>
        </Header>
      </div>
    )
  }
}

export default MainHeader;



// WEBPACK FOOTER //
// src/components/Header.js